"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var storeApi = _interopRequireWildcard(require("@/api/store"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'EditRelationDialog',
  data: function data() {
    return {
      dialogVisible: false,
      mainGoodsId: null,
      mainGoodsName: '',
      businessType: '',
      searchKeyword: '',
      goodsLoading: false,
      allGoodsList: [],
      selectedGoodsList: [],
      submitting: false,
      goodsPage: 1,
      pageSize: 6,
      goodsTotalCount: 0,
      dragIndex: -1,
      dragTargetIndex: -1
    };
  },
  computed: {
    showGoodsList: function showGoodsList() {
      return this.allGoodsList.length > 0;
    },
    pagedGoodsList: function pagedGoodsList() {
      return this.allGoodsList;
    },
    goodsTotal: function goodsTotal() {
      return this.goodsTotalCount;
    }
  },
  methods: {
    open: function open(manageId) {
      var _this = this;
      this.mainGoodsId = manageId;
      this.mainGoodsName = '';
      this.businessType = '';
      this.searchKeyword = '';
      this.allGoodsList = [];
      this.selectedGoodsList = [];
      this.goodsPage = 1;
      this.goodsTotalCount = 0;
      this.dragIndex = -1;
      this.dragTargetIndex = -1;
      storeApi.oneCardRightConfigDetail({
        manageId: manageId
      }).then(function (data) {
        _this.mainGoodsId = data.manageId;
        _this.mainGoodsName = data.mainGoodsName || '';
        _this.selectedGoodsList = (data.rights || []).map(_this.mapProduct);
        _this.dialogVisible = true;
      }).catch(function (err) {});
    },
    handleClose: function handleClose() {},
    handleSearchGoods: function handleSearchGoods() {
      this.goodsLoading = true;
      this.goodsPage = 1;
      this.loadProductOptions();
    },
    loadProductOptions: function loadProductOptions() {
      var _this2 = this;
      this.goodsLoading = true;
      storeApi.oneCardRightProductOptions({
        businessType: this.businessType || undefined,
        keyword: this.searchKeyword || undefined,
        page: this.goodsPage,
        limit: this.pageSize
      }).then(function (data) {
        _this2.allGoodsList = (data.list || []).map(_this2.mapProduct);
        _this2.goodsTotalCount = data.total || 0;
      }).catch(function () {
        _this2.allGoodsList = [];
        _this2.goodsTotalCount = 0;
      }).finally(function () {
        _this2.goodsLoading = false;
      });
    },
    mapProduct: function mapProduct(item) {
      return {
        id: item.relatedProductId,
        spuId: item.spuId || item.relatedProductId,
        goodsName: item.productName || '',
        storeName: item.storeName || '',
        productCode: item.productCode || '',
        price: item.price || 0,
        businessType: item.businessType,
        reserveLimit: item.useCount || 1,
        unlimited: item.unlimitedFlag === 1
      };
    },
    handleGoodsPageChange: function handleGoodsPageChange(page) {
      this.goodsPage = page;
      this.loadProductOptions();
    },
    handleLimitChange: function handleLimitChange(id, val) {
      var item = this.allGoodsList.find(function (it) {
        return it.id === id;
      });
      if (item) item.reserveLimit = val;
      var sel = this.selectedGoodsList.find(function (it) {
        return it.id === id;
      });
      if (sel) sel.reserveLimit = val;
    },
    handleUnlimitedChange: function handleUnlimitedChange(id, val) {
      var item = this.allGoodsList.find(function (it) {
        return it.id === id;
      });
      if (item) {
        item.unlimited = val;
        if (val) item.reserveLimit = 1;
      }
      var sel = this.selectedGoodsList.find(function (it) {
        return it.id === id;
      });
      if (sel) {
        sel.unlimited = val;
        if (val) sel.reserveLimit = 1;
      }
    },
    handleAddGoods: function handleAddGoods(row) {
      var exists = this.selectedGoodsList.find(function (it) {
        return it.id === row.id;
      });
      if (exists) {
        this.$message.warning('该商品已添加');
        return;
      }
      if (this.selectedGoodsList.length >= 50) {
        this.$message.warning('最多关联50个商品');
        return;
      }
      this.selectedGoodsList.push(_objectSpread({}, row));
    },
    isGoodsSelected: function isGoodsSelected(id) {
      return this.selectedGoodsList.some(function (item) {
        return item.id === id;
      });
    },
    handleRemoveGoods: function handleRemoveGoods(id) {
      var idx = this.selectedGoodsList.findIndex(function (it) {
        return it.id === id;
      });
      if (idx > -1) this.selectedGoodsList.splice(idx, 1);
    },
    handleDragStart: function handleDragStart(index, event) {
      this.dragIndex = index;
      event.dataTransfer.effectAllowed = 'move';
    },
    handleDragOver: function handleDragOver(index) {
      if (this.dragIndex < 0 || this.dragIndex === index) return;
      this.dragTargetIndex = index;
      var dragItem = this.selectedGoodsList[this.dragIndex];
      this.selectedGoodsList.splice(this.dragIndex, 1);
      this.selectedGoodsList.splice(index, 0, dragItem);
      this.dragIndex = index;
    },
    handleDragEnd: function handleDragEnd() {
      this.dragIndex = -1;
      this.dragTargetIndex = -1;
    },
    handleSubmit: function handleSubmit() {
      var _this3 = this;
      if (!this.mainGoodsId) {
        this.$message.warning('请选择主商品');
        return;
      }
      var payload = {
        manageId: this.mainGoodsId,
        rights: this.selectedGoodsList.map(function (item, index) {
          return {
            relatedProductId: item.id,
            useCount: item.unlimited ? null : item.reserveLimit,
            unlimitedFlag: item.unlimited ? 1 : 0,
            sort: index + 1
          };
        })
      };
      this.submitting = true;
      storeApi.oneCardRightConfigSave(payload).then(function () {
        _this3.$message.success('保存成功');
        _this3.dialogVisible = false;
        _this3.$emit('saved');
      }).finally(function () {
        _this3.submitting = false;
      });
    }
  }
};